var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticStyle:{"max-width":"600px","margin":"0 auto"}},[_c('v-col',{staticClass:"pb-0 mb-0",attrs:{"id":"base","md":"12"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }